var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-835-430H605V594H-835z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-706-21H506v52H-706z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C853",
    fillRule: "nonzero",
    d: "M6 1C3.24 1 1 3.24 1 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM4.645 8.145L2.85 6.35a.498.498 0 11.705-.705L5 7.085l3.44-3.44a.498.498 0 11.705.705L5.35 8.145a.498.498 0 01-.705 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.140c35de19ae68027bbd1edff65c0d1e.svg";
export { ForwardRef as ReactComponent };